const listOfExperiments = ['']

export default {
    state: {
    },

    mutations: {
    },

    actions: {
        loadShowsPickerVariants({ state, commit, dispatch }) {
            return dispatch('loadVariantsXhr', listOfExperiments);
        },
    },

    getters: {
    },
};
